

import React from "react"
import Gallery from "react-grid-gallery";

import sine from "../images/gmic_chaos/sine.png"
import crush from "../images/gmic_chaos/crush.png"
import jelly from "../images/gmic_chaos/jelly.jpg"
import glow from "../images/gmic_chaos/glow.jpg"
import wolle from "../images/gmic_chaos/wolle.png"
import field from "../images/gmic_chaos/field.png"
import rai from "../images/gmic_chaos/rai.png"


import { Container, Row, Col } from "react-bootstrap";
const w = 400;
const h = 400;


const IMAGES = [
   {
     src: sine,
     thumbnail:
     sine,
     thumbnailWidth: w,
     thumbnailHeight: h,
     caption: "Simple sinewave "
   },

  {
    src: crush,
    thumbnail:
      crush,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "cave "
  },
  {
    src: jelly,
    thumbnail:
      jelly,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "Inside"
  },
  {
    src: glow,
    thumbnail:
      glow,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "nice"
  },

  {
    src: wolle,
    thumbnail:
      wolle,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "Wolle"
  },

  {
    src: field,
    thumbnail:
      field,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "Field"
  },

  {
    src: rai,
    thumbnail:
      rai,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "rai cover"
  },




];


const GmicChaos = () => {
  return (
    <>
      <Container>
        <Row>
          <Col>
          <p style={{textAlignVertical: "center",textAlign: "center",}}>Using Gmic and Python to create abstract images using randomised values and filters</p>
          </Col>
          <Col> <div style={{
          }}>
            <Gallery
              images={IMAGES}
              enableLightbox={true}
              backdropClosesModal
            />
          </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  )
}

export default GmicChaos
